/* eslint-disable react/prop-types */ // TODO: add props
import { Children, cloneElement, useState, useEffect } from 'react';
import PT from 'prop-types';
import cx from 'classnames';
import style from './styles.scss';

const Collapse = ({ children, isOpen: open }) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open, setIsOpen]);

  return (
    <div className={cx(style.collapse, { [style.isOpen]: isOpen })}>
      {Children.map(children, (child) =>
        child ? cloneElement(child, { isOpen, setIsOpen }) : null
      )}
    </div>
  );
};

export const Header = ({ children, isOpen, setIsOpen, onClick }) => (
  <button
    className={style.header}
    type="button"
    aria-label="Toggle Collapse"
    onClick={() => (onClick ? onClick() : setIsOpen(!isOpen))}
  >
    {children}
  </button>
);

export const Body = ({ children }) => {
  return <div className={style.body}>{children}</div>;
};

Collapse.propTypes = {
  children: PT.node.isRequired,
  isOpen: PT.bool,
};

Header.propTypes = {
  children: PT.node.isRequired,
  isOpen: PT.bool,
  onClick: PT.func,
};

Body.propTypes = {
  children: PT.node.isRequired,
};

Collapse.defaultProps = {
  isOpen: false,
};

export default Object.assign(Collapse, {
  Collapse,
  Header,
  Body,
});
